<template>
  <div ref="rootRef">
    <VmNicSelect
      :options="options"
      :initial-value="selectedValue"
      input-name="migration[target_storage_id]"
      empty-label="Select destination storage"
      filter-placeholder="Filter destination storages"
      :readonly="!options.length"
      @update:value="handleValueUpdate"
    />
    <p v-if="validationError" class="text-danger storage-migration-select__error">
      {{ validationError }}
    </p>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from "vue"
import VmNicSelect from "./VmNicSelect.vue"

const props = defineProps({
  options: {
    type: Array,
    default: () => []
  }
})

const rootRef = ref(null)
const selectedValue = ref("")
const validationError = ref("")
let formElement = null

function handleValueUpdate(value) {
  selectedValue.value = String(value || "")
  validationError.value = ""
}

function validateSelection(event) {
  if (selectedValue.value) return
  event.preventDefault()
  validationError.value = "Select a destination storage."
}

onMounted(() => {
  formElement = rootRef.value?.closest("form") || null
  formElement?.addEventListener("submit", validateSelection)
})

onBeforeUnmount(() => {
  formElement?.removeEventListener("submit", validateSelection)
})
</script>

<style scoped>
.storage-migration-select__error {
  margin: 6px 0 0;
  font-size: 12px;
}
</style>
